import Commons from '../../../../Services/Common/Common';

export const DEP_HAN_Schema = {
  fields: {
    no: { initial: '', label: 'No' },
    depCd: { initial: '', label: '부서코드' },
    depNm1: { initial: '', label: '사업장명', required: 'Y' },
    depNm2: { initial: '', label: '회사명' },
    depNm3: { initial: '', label: '부서명' },
    depNm4: { initial: '', label: '파트' },
  },

  mapper: {
    search1: {
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
    save1: {
      DepCd: (row) => Commons.EncryptAES(row.depCd || '') || '',
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd) || '',
      DepNm1: (row) => Commons.EncryptAES(row.depNm1 || '') || '',
      DepNm2: (row) => Commons.EncryptAES(row.depNm2 || '') || '',
      DepNm3: (row) => Commons.EncryptAES(row.depNm3 || '') || '',
      DepNm4: (row) => Commons.EncryptAES(row.depNm4 || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      DepCd: (row) => Commons.EncryptAES(row.depCd || '') || '',
    },
  },
};
